<template>
  <div>
    <w-sliding-popup type="setting"  ref="slidingPopup" class="add-log-head" :title="title" width="500px" @close="resetFields">
      <div slot="content">
        <el-steps :active="activeStep" finish-status="success">
          <el-step v-for="(step, index) in stepTitles" :key="index" :title="`${index + 1}.${step}`"></el-step>
        </el-steps>
        <el-row v-show="activeStep === 1">
          <w-applog-basic-setting ref="applogBasicSetting" :formData="formData" :isAdd="isAdd" :server-id="selectApplogGroup.serverId"></w-applog-basic-setting>
        </el-row>
        <el-row v-show="activeStep === 2">
          <w-applog-lms-setting ref="applogLmsSetting" :formData="formData" :isAdd="isAdd"></w-applog-lms-setting>
        </el-row>
      </div>
      <el-row slot="footer"  type="flex" justify="space-between">
        <div>
          <el-button size="large" v-show="activeStep !== 1" @click="prevStep">이전 단계</el-button>
        </div>
        <div>
          <span v-if="activeStep === 2">
            <el-button size="large" type="solid" @click="settingApplog">저장</el-button>
          </span>
          <el-button size="large" type="solid" v-else @click="nextStep">다음 단계</el-button>
          <el-button size="large" @click="close">취소</el-button>
        </div>
      </el-row>
    </w-sliding-popup>
  </div>
</template>

<script>
import LmsApplogAPI from '@/api/settings/log/lms-applog-setting';
import WSettingSlidingPopup from '@/components/popup/SettingSlidingPopup/SettingSlidingPopup';
import msgUtil from '@/utils/message';
import rsaEncrypt from '@/utils/rsa-encrypt';

import { isNil, cloneDeep } from 'lodash';
import WApplogBasicSetting from '../component/ApplogBasicSetting';
import WApplogLmsSetting from '../component/ApplogLmsSetting';

export default {
  name: 'WAppLogPopup',
  components: {
    WSettingSlidingPopup,
    WApplogLmsSetting,
    WApplogBasicSetting,
  },
  props: {
    logCollectorId: {
      type: Number,
    },
    selectApplogGroup: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
    settingData: {
      type: Object,
      deafult: {},
    },
    selectPhysicalNode: {
      type: Object,
    },
  },
  watch: {
    isAdd: {
      handler() {
        this.title = (this.isAdd) ? '로그 추가' : '로그 수정';
        if (this.isAdd) {
          this.resetFormData();
        }
      },
      immediate: true,
    },
    settingData: {
      immediate: true,
      deep: true,
      handler() {
        if (!this.isAdd) {
          this.formData = cloneDeep(this.settingData);
        } else {
          this.resetFormData();
        }
        if (this.formData.patternFlag === 'Y') {
          const appName = this.formData.applogFile;
          const patternArray = appName.split(this.formData.pattern);
          this.formData.beforePattern = patternArray[0];
          this.formData.afterPattern = patternArray[1];
        }
      },
    },
    immediate: true,
  },
  data() {
    return {
      activeStep: 1,
      title: '로그 추가',
      stepTitles: ['기본 설정', '통합 설정'],
      formData: {
        logCollectorId: '',
        logInfo: {
          patternId: null,
          logSaveFileFlag: 'Y',
          compressFlag: 'Y',
          encryptFlag: 'N',
          retentionAge: '1',
          dataindexId: null,
        },
        applogId: null,
        applogDir: null,
        applogGroupId: 'WatchAll',
        applogType: 'T',
        applogFileAttrib: 'F',
        applogSaveDbFlag: '1',
        applogSaveFileFlag: '1',
        patternFlag: 'N',
        applogRawDelFlag: '0',
        applogRealtimeSendFlag: '1',
        applogRawDelInteval: 'D',
        orderbyIndex: null,
        applogDesc: null,
        objLinkId: null,
      },
    };
  },
  methods: {
    prevStep() {
      this.activeStep = this.activeStep - 1;
    },
    nextStep() {
      this.$refs.applogBasicSetting.$refs.form.validate().then((success) => {
        if (success) {
          this.activeStep += 1;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', false));
        }
      }).catch(() => {});
    },
    /**
     * 데이터 Null 처리
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    convertNullData(data) {
      return isNil(data) ? '' : data;
    },
    /**
     * 로그 추가
     * @author leesy918
     */
    settingApplog() {
      this.$refs.applogLmsSetting.$refs.formLms.validate().then((success) => {
        if (success) {
          if (this.isAdd) {
            this.saveApplog();
          } else {
            this.updateApplog();
          }
        }
      }).catch(() => {});
    },
    /**
     * 어플리케이션 로그 수집 설정 저장
     * @author leesy918
     * @return {[type]} [description]
     */
    saveApplog() {
      this.formData.objId = this.selectPhysicalNode.objId;
      this.formData.serverId = this.selectApplogGroup.serverId;
      this.formData.logCollectorId = this.logCollectorId;

      if (this.formData.logInfo.logSaveFileFlag === 'N' || this.formData.logInfo.encryptFlag === 'N') {
        this.formData.logInfo.encryptPw = null;
      }
      if (this.formData.patternFlag === 'Y') {
        this.formData.applogFile = `${this.convertNullData(this.formData.beforePattern)}${this.convertNullData(this.formData.pattern)}${this.convertNullData(this.formData.afterPattern)}`;
      }
      this.formData.applogGroupId = this.selectApplogGroup.applogGroupId;
      if (this.formData.applogRawDelFlag === '0') {
        this.formData.applogRawDelInteval = '';
      }

      const logInfo = this.formData.logInfo;
      const fieldData = {
        encryptPw: logInfo.encryptPw,
      };
      rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
        const params = cloneDeep(this.formData);
        params.logInfo.encryptPw = encryData.encryptPw;
        LmsApplogAPI.addLmsApplog(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', true));
            this.$emit('addApplogInGroup');
            this.close();
            this.reset();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', false));
          }
        });
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, '로그', false));
        throw new Error(e);
      });
    },
    /**
     * 어플리케이션 로그 수정
     * @author leesy918
     * @return {[type]} [description]
     */
    updateApplog() {
      if (this.formData.logInfo.logSaveFileFlag === 'N' || this.formData.logInfo.encryptFlag === 'N') {
        this.formData.logInfo.encryptPw = null;
      }
      if (this.formData.patternFlag === 'Y') {
        this.formData.applogFile = `${this.convertNullData(this.formData.beforePattern)}${this.convertNullData(this.formData.pattern)}${this.convertNullData(this.formData.afterPattern)}`;
      }
      if (this.formData.applogRawDelFlag === '0') {
        this.formData.applogRawDelInteval = '';
      }

      const logInfo = this.formData.logInfo;
      const fieldData = {
        encryptPw: logInfo.encryptPw,
      };
      rsaEncrypt.getRsaEncrypt(fieldData).then((encryData) => {
        const params = cloneDeep(this.formData);
        params.logInfo.encryptPw = encryData.encryptPw;
        LmsApplogAPI.updateLmsApplog(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그', true));
            this.$emit('addApplogInGroup');
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그', false));
          }
        });
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '로그', false));
        throw new Error(e);
      });
    },
    /**
     * 팝업 Data 초기화
     * @author leesy918
     */
    reset() {
      this.formData = {
        logCollectorId: '',
        logInfo: {
          patternId: null,
          logSaveFileFlag: 'Y',
          compressFlag: 'Y',
          encryptFlag: 'N',
          retentionAge: '1',
          dataindexId: null,
        },
        applogId: null,
        applogDir: null,
        applogGroupId: 'WatchAll',
        applogType: 'T',
        applogFileAttrib: 'F',
        applogSaveDbFlag: '1',
        applogSaveFileFlag: '1',
        patternFlag: 'N',
        applogRawDelFlag: '0',
        applogRealtimeSendFlag: '1',
        applogRawDelInteval: 'D',
        orderbyIndex: null,
        applogDesc: null,
        objLinkId: null,
      };
    },
    open() {
      this.activeStep = 1;
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.$refs.applogLmsSetting.getApplogSettingData(this.selectApplogGroup.serverId);
      });
    },
    close() {
      this.activeStep = 1;
      this.resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 수집기 아이디를 포함한 초기화
     * @author leesy918
     */
    resetFormData() {
      this.formData = {
        logCollectorId: this.settingData.logCollectorId,
        logInfo:
          {
            patternId: null,
            logSaveFileFlag: 'Y',
            compressFlag: 'Y',
            encryptFlag: 'N',
            retentionAge: '1',
            dataindexId: null,
          },
        applogId: null,
        applogDir: null,
        applogGroupId: 'WatchAll',
        applogType: 'T',
        applogFileAttrib: 'F',
        applogSaveDbFlag: '1',
        applogSaveFileFlag: '1',
        patternFlag: 'N',
        applogRawDelFlag: '0',
        applogRealtimeSendFlag: '1',
        applogRawDelInteval: 'D',
        orderbyIndex: null,
        applogDesc: null,
        objLinkId: null,
      };
    },
    resetFields() {
      this.$refs.applogBasicSetting.$refs.form.resetFields();
      this.$refs.applogLmsSetting.$refs.formLms.resetFields();
      this.$refs.applogLmsSetting.resetData();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Applog/popup/AppLogPopup.vue